<template>
  <div></div>
</template>
<script>
import PushNotificationManager from '@/push_notification_manager';
import { mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      getStudentClasses: 'classroom/getStudentClasses',
    }),
  },
  methods: {
    ...mapActions({
      storeWebPushInfo: 'users/storeWebPushInfo',
    }),
    getClassByClassId(classId) {
      const selectedClass = this.getStudentClasses.filter(
        x => x._id === classId,
      )[0];
      return selectedClass;
    },
    pushSubscriptionHandler() {
      PushNotificationManager.checkSubscriptionStatus(
        (checkSubscriptionResponse) => {
          if (
            checkSubscriptionResponse.isSubscribed != undefined &&
            checkSubscriptionResponse.isSubscribed
          ) {
            // ServiceWorker active
            PushNotificationManager.unsubscribeUser((unsubscribeResponse) => {
              if (
                unsubscribeResponse.isUnsubscribe != undefined &&
                unsubscribeResponse.isUnsubscribe
              ) {
                // Unsubscribe success
                PushNotificationManager.startRegistration(
                  (startRegistrationResponse) => {
                    if (startRegistrationResponse.isAccept) {
                      // Registration Success
                      const data = {
                        device_token: this.deviceToken,
                        endpoint: startRegistrationResponse.endpoint,
                        auth: startRegistrationResponse.auth,
                        p256dh: startRegistrationResponse.p256dh,
                      };
                      this.storeWebPushInfo(data);
                    }
                  },
                );
              }
            });
          }
        },
      );
    },
  },
};
</script>
